module.exports = __webpack_public_path__ + "static/media/magic2.c879c5db.jpg";